import formatDate from 'ember-intl/helpers/format-date';
import add from 'ember-math-helpers/helpers/add';
import lt from 'ember-truth-helpers/helpers/lt';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import type DiabguideRecommendation from 'parog-web/models/diabguide-recommendation';
import DiabguideRecommendationComputedJournalEvent from 'parog-web/models/diabguide-recommendation-computed-journal-event';
import NoContentMessage from 'ui-kit/components/no-content-message';

export default class DiabguideEditionFormComponent extends CrudJournalEventBaseComponent<DiabguideRecommendationComputedJournalEvent> {
  static override forcDisplayName: 'Recommandations Diabguide';
  static override fullComponentId: 'diabguide-recommendation/edition-form';
  static override journalEventClass =
    DiabguideRecommendationComputedJournalEvent;

  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;

  get datas(): DiabguideRecommendation {
    return this.changeset.data['data'];
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content>
        <div class='ui header'>
          Date de la recommandation :
          {{formatDate this.typedChangeset.occurredAt}}
        </div>
        <h3 class='ui header'>Risque cardiaque</h3>
        <div>
          <p>Risque : {{this.datas.cardioRisk.label}}</p>
          <p>{{this.datas.cardioRisk.note}}</p>
        </div>
        <h3 class='ui header'>Objectifs glycémique</h3>
        <div>
          <p>HBA: {{this.datas.glycemicObjectives.hba}}</p>
          <p>{{this.datas.glycemicObjectives.subtitle}}</p>
          <p>{{this.datas.glycemicObjectives.note}}</p>
        </div>
        <h3 class='ui header'>Objectifs lipidique</h3>
        <div>
          <p>LDL: {{this.datas.lipidObjectives.ldl}}</p>
          <p>{{this.datas.lipidObjectives.note}}</p>
        </div>
        <h3 class='ui header'>Objectifs tension artérielle</h3>
        <div>
          <p>Systolique:
            {{this.datas.bloodPressureObjectives.systolic.label}}</p>
          <p>Diastolique:
            {{this.datas.bloodPressureObjectives.diastolic.label}}</p>
          <p> {{this.datas.bloodPressureObjectives.note}}</p>
        </div>
        <h3 class='ui header'>Si votre patient n’est pas à l’objectif, la
          stratégie thérapeutique est la suivante :</h3>
        <lo class='list-outside list-[decimal]'>
          {{#each this.datas.therapeuticStrategy as |item index|}}
            <li class='my-2'>
              <span>{{item.label}}<br /></span>
              <span>{{item.info}} {{#if item.info}} <br />{{/if}}</span>
              {{#each item.children as |child|}}
                <span>{{child.label}} {{child.choice}}<br /></span>
              {{/each}}
            </li>
            {{#if (lt (add index 1) this.datas.therapeuticStrategy.length)}}
              <NoContentMessage>
                Si objectif non atteint ...
              </NoContentMessage>
            {{/if}}
          {{/each}}
        </lo>
      </:content>
    </Provider>
  </template>
}
